import { watchNowSelected, browseContentSelected } from '@/Analytics/Segment';

export const watchNowClicked = () => {
  watchNowSelected();
};

export const browseContentClicked = () => {
  browseContentSelected();
};
